import { render, staticRenderFns } from "./StartSequences.vue?vue&type=template&id=a84343a0&scoped=true&"
import script from "./StartSequences.vue?vue&type=script&lang=js&"
export * from "./StartSequences.vue?vue&type=script&lang=js&"
import style0 from "./StartSequences.vue?vue&type=style&index=0&id=a84343a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84343a0",
  null
  
)

export default component.exports